import { render, staticRenderFns } from "./r-list.vue?vue&type=template&id=fbd2185a&"
import script from "./r-list.vue?vue&type=script&lang=js&"
export * from "./r-list.vue?vue&type=script&lang=js&"
import style0 from "./r-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports